import { parentUrlParam } from '@/app.config'

export const getRawParentUrl = () => {
  return window.location !== window.parent.location
    ? parentUrlParam
    : document.location.href
}

export const getParentDomain = () => {
  const parentUrl = getRawParentUrl()
  return parentUrl
    .split('/')
    .slice(0, 3)
    .join('/')
}

export const isProbablyCRM = () => {
  const parentDomain = getParentDomain()
  return /crmportal|crmdemo|serviceportal|mietme\.|meine\.d/.test(parentDomain)
}
export const isCRMLoginPage = url => {
  return /\/site\/login\/anmeldung/.test(url)
}

export function normalizeBoolean(value) {
  if (typeof value === 'boolean') {
    return value
  } else if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }

  return false
}

export const groupBy = function(data, key) {
  return data.reduce(function(storage, item) {
    let group = item[key]

    storage[group] = storage[group] || []

    storage[group].push(item.points)

    return storage
  }, {})
}

export const matchMessage = (message, metadata) => {
  return (
    message.timestamp === metadata.is_regenerated_from ||
    (Array.isArray(message) &&
      message[0].timestamp === metadata.is_regenerated_from) ||
    (Array.isArray(message[0]) &&
      message[0][1].timestamp === metadata.is_regenerated_from)
  )
}

export function checkIfSoloSourceMessage(message) {
  const listRegex = /<ul[^>]*>/g
  const sourcesRegex = /Quellen:\s*<ul[^>]*>(.*?)<\/ul>/g

  return (
    message &&
    Boolean(message.text.match(listRegex)) &&
    Boolean(message.text.match(sourcesRegex))
  )
}
